import { z } from 'zod'

export const loginSchema = z.object({
  email: z.email('Enter a valid email address.').max(180),
  password: z.string().min(1, 'Enter your password.').max(4096),
  remember: z.boolean(),
})

export type LoginForm = z.infer<typeof loginSchema>

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Enter your current password.'),
    newPassword: z.string().min(8, 'Use at least 8 characters.').max(128),
    confirmPassword: z.string(),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match.',
  })

export type ChangePasswordForm = z.infer<typeof changePasswordSchema>
